module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray-813ff4a8570dbe108e301fa782205bc5.png";